import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    HardDeleteAccount as HardDeleteAccountMutation,
    HardDeleteAccountVariables,
} from 'nutshell-graphql-types';

import HARD_DELETE_ACCOUNT from '../mutations/hard-delete-account.graphql';

export const useHardDeleteAccount = (): {
    hardDeleteAccount: (accountId: string) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [hardDeleteAccount, {loading, error}] = useMutation<
        HardDeleteAccountMutation,
        HardDeleteAccountVariables
    >(HARD_DELETE_ACCOUNT);

    return {
        hardDeleteAccount: (accountId: string) => hardDeleteAccount({variables: {accountId}}),
        isLoading: loading,
        // @ts-expect-error
        error: error && safelyGetGraphQLErrorMessage(error),
    };
};
